import React, { Component } from 'react';
import Api from '../../helpers/api';

class ContentImage extends Component {
  state = {
    src: '',
  };

  componentDidMount() {
    this.generateSignedUrlByKey(this.props.contentKey).then(src => {
      this.setState({ src });
    });
  }

  generateSignedUrlByKey = async key => {
    const userGuidesUrlApi = new Api('user_guides/url');

    const url = await userGuidesUrlApi
      .multipleParamsGetRequest({ key: encodeURIComponent(key) })
      .then(response => response.data.success.data.url);

    return url;
  };

  render() {
    const { src } = this.state;

    return src && <img alt="content-user-guide" src={src} />;
  }
}

export default ContentImage;
